import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { SettingsSection } from "components/Settings/SettingsSection";
import { Link } from "react-router-dom";
import { useLoadCounter } from "hooks/useLoadCounter";

export const ComponentsSection = () => {
  const {
    loading: componentsLoading,
    error: componentsError,
    response: componentsResponse
  } = useFetchGetV2("components?ordering=id");
  const tableLoadCount = useLoadCounter(componentsLoading);

  if (componentsLoading) {
    return <></>;
  }

  if (componentsError) {
    return <></>;
  }

  if (componentsResponse) {
    return (
      <>
        <SettingsSection title="Components">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell data-col={1}>ID</TableCell>
                  <TableCell data-col={2}>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                data-qa_loading={componentsLoading}
                data-qa_load_count={tableLoadCount}
              >
                {componentsResponse &&
                  componentsResponse?.results.map(component => (
                    <TableRow key={component.id}>
                      <TableCell data-col={1}>{component.id}</TableCell>
                      <TableCell data-col={2}>
                        <Link to={`/pages/settings/component/${component.id}`}>
                          {`${component.name}`}
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SettingsSection>
      </>
    );
  }
};
